import * as React from "react";
import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import { Client } from "../../../../domain/model/client";
import { Company } from "../../../../domain/model/company";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import { TBreadcrumbItem } from "../../../type/common";
import ClientMypageInfoClientMain from "./info_client/client_mypage_info_client_main";

interface IProps {
  isLoading: boolean;
  client: Client | null;
  company: Company | null;
}

const ClientMyPageClientInfoComponent: React.FC<IProps> = (props) => {
  const { isLoading, client, company } = props;

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.clientRoot,
    routeConfig.clientMypage,
  ];

  return (
    <React.Fragment>
      {isLoading && <Progress canAnimation={false} />}

      <PageWrapper>
        <Breadcrumbs breadcrumbItems={breadcrumbItems} />
        <ClientMypageInfoClientMain client={client} company={company} />
      </PageWrapper>
    </React.Fragment>
  );
};

export default ClientMyPageClientInfoComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/mypage/client_mypage_info_client.tsx